import * as React from "react"
import { Modal, Row, Button, Form, Container, Table, Col } from "react-bootstrap"
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { Pool } from "../../../api/Randoms/RandomsModel/PoolData"
import FormatError from "../../../formatters/FormatError"
import { APIError } from "../../../api/ObservableFromFetch"
import { RunCancelPoolsMessages, RunCancelPoolsObservable } from "../../../api/Randoms/RandomSelectionRun"
import RunCancelNotificationModal from "./RunCancelNotificationModal"
import SelectPoolForRunGrid from "./SelectPoolForRunGrid"

interface RunCancelModalProps {
  poolsData: Pool[]
  cancel: boolean
  isConsortium: boolean
  onClose: () => void
  onUpdate: () => void
}

interface RunCancelModalState {
  saving: boolean
  showConfirmation: boolean
  selectedPools: Pool[]
  selectAll: boolean
  allPoolsChecked: boolean
  messages: RunCancelPoolsMessages[]
}

export default class RunCancelModal extends React.Component<RunCancelModalProps, RunCancelModalState> {
  subscription?: Subscription

  state: RunCancelModalState = {
    saving: false,
    showConfirmation: false,
    selectedPools: [],
    selectAll: true,
    allPoolsChecked:false,
    messages: []
  }

  saveSubscription?: Subscription

  componentWillUnmount() {
    this.saveSubscription && this.saveSubscription.unsubscribe()
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error(FormatError(error))
  }


  handleClose = () => {
    this.props.onClose()
  }

  handleCheckPool = (pools: Pool[], checked: boolean) => {
    const { selectedPools } = this.state

    const updatedPools = checked
      ? [...selectedPools, ...pools]
      : selectedPools.filter((item) => !pools.includes(item))

      const isAllPoolsChecked = this.isAllInclude(selectedPools, this.props.poolsData)
    this.setState({ selectedPools: updatedPools, allPoolsChecked: isAllPoolsChecked })
  }

  handleSelectAllRowsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({allPoolsChecked: e.target.checked, selectedPools: e.target.checked ? this.props.poolsData : []})
  }

  isAllInclude = (source: Pool[], target: Pool[]): boolean =>
  {
    const result:boolean = target.every(t => {
        return source.some(s => t.PoolID === s.PoolID);
        });
   return result
  }

  executeRunCancel = () => {
    this.setState({ saving: true })
    const { selectAll, selectedPools } = this.state
    let pools = selectAll ? this.props.poolsData : selectedPools
    const poolsData = pools.map(p => { return { PoolID: p.PoolID, PoolName: p.PoolName, PoolCode: p.Code, IsConsortium: p.IsConsortium } })

    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveSubscription = RunCancelPoolsObservable(this.props.cancel, poolsData).subscribe(
      data => {
        this.setState({ saving: false, messages: data })
        toast.success("Action executed successfully.")
      },
      error => {
        this.handleAPIError(error, { saving: false })
        this.closeConfirmation()
      }
    )
  }

  handleConfirm = () => this.setState({ showConfirmation: true })

  closeConfirmation = () => {
    this.setState({ showConfirmation: false })
    if (this.state.messages.length > 0) this.props.onUpdate()
  }

  render() {
    const { cancel, poolsData, isConsortium } = this.props
    const { selectedPools, selectAll, saving, messages, showConfirmation, allPoolsChecked } = this.state

    return (
      <>
        {showConfirmation && <RunCancelNotificationModal
          confirmationText={`Are you sure you want to ${ cancel ? "Cancel" : "Run" } ${ isConsortium ? "Consortiums" : "Pools" }?`}
          notes={messages}
          loading={saving}
          isConsortium={this.props.isConsortium}
          onHide={this.closeConfirmation}
          onSubmit={() => this.executeRunCancel()}/>}
        <Modal backdrop="static" size={cancel ? "lg" : "xl"} centered show onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{`Select ${ isConsortium ? "Consortiums" : "Pools" } to ${ cancel ? "Cancel" : "Run" }`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="text-center">
              <Col>
                <Form.Check inline id="pools-all" name="pools" type="radio" label={`All ${ isConsortium ? "Consortiums" : "Pools" }`} className="abc-radio mx-2 ml-auto" checked={selectAll} onChange={() => this.setState({ selectAll: true })} />
                <Form.Check inline id="pools-selected" name="pools" type="radio" label={`Selected ${ isConsortium ? "Consortiums" : "Pools" }`} className="abc-radio mx-2 mr-auto" checked={!selectAll} onChange={() => this.setState({ selectAll: false, selectedPools: [] })} />
              </Col>
            </Row>
            {!selectAll && <Container fluid className="mt-2 p-0" style={{ maxHeight: "400px", overflowY: "scroll", overflowX: "hidden" }}>
                <SelectPoolForRunGrid
                  pools={poolsData}
                  selectedPools={selectedPools}
                  isConsortium={isConsortium}
                  cancel={cancel}
                  onSelectPool={this.handleCheckPool}
                />
            </Container>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" disabled={!selectAll && selectedPools.length == 0} onClick={() => this.handleConfirm()}>Execute</Button>
            <Button variant="secondary" onClick={() => this.handleClose()}>Cancel</Button>
          </Modal.Footer>
        </Modal >
      </>
    )
  }
}
